import { render, staticRenderFns } from "./EntityChip.vue?vue&type=template&id=dead4558"
import script from "./EntityChip.vue?vue&type=script&lang=js"
export * from "./EntityChip.vue?vue&type=script&lang=js"
import style0 from "./EntityChip.vue?vue&type=style&index=0&id=dead4558&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports